<template>
  <div class="d-flex flex-column justify-center align-center">

    <!--  header-->
    <TriangleHeader :title="$t('gallery')"/>
    <!--    end header-->


    <!--    Start Tabs-->
    <v-row class="w-80 mt-16" v-if="categories && categories[0]">
      <v-col v-for="(filter,index) in categories[0].sub_categories"
             :key="index"
             @click="selectedTab=index"
      >


        <div :class="[selectedTab===index?'selected-tab':'tab-item']">
          {{ filter.title }}
        </div>
      </v-col>
    </v-row>
    <!--    End Tabs-->
    <!--    Start List-->
    <div style="margin: 180px auto" v-if="loading">
      <v-progress-circular
          indeterminate
          color="black"
      ></v-progress-circular>
    </div>
    <v-row v-else  class="mb-16 w-80">
      <div v-if="gallery.topics==undefined" class="d-flex justify-center align-center text-center w-100 mt-8">
        {{ gallery.msg }}
      </div>
      <v-col class="px-1" v-else cols="12" xl="4" lg="4" md="4"
             style="height: 340px!important;"
             v-for="item in gallery.topics">
        <GalleryItem :item="item" />
      </v-col>

    </v-row>
    <!--    End List-->
  </div>
</template>

<script>
import NewsItem from "../../components/news_item/NewsItem";

import TriangleHeader from "../../components/triangle_header/TriangleHeader";
import {GET_NEWS} from "../../store/newsManagement/action_types";
import state from "../../store/newsManagement/state";
import {mapState} from "vuex";
import {
  GET_GAllERY,
  GET_IMAGES,
  GET_VIDEOS
} from "../../store/eventManagement/action_types";
import GalleryItem from "../../components/news_item/GalleryItem";
import {getApi} from '@/data/ApiService'
export default {
  name: "Gallery",
  components: {GalleryItem, TriangleHeader, NewsItem},
  data() {
    return {
      selectedTab: 0,
      categories:[],
      filters: [
        {
          id: 0,
          title: 'همه'
        },
        {
          id: 1,
          title: 'تصاویر'
        },
        {
          id: 2,
          title: 'ویدئو ها'
        },
      ],
    }
  },
  methods: {
    getData() {
      switch (this.selectedTab) {
        case 0:
          this.getAll();
          break;
        case 1:
          this.getImages();
          break;

        case 2:
          this.getVideos();
          break;

      }
    },
    getAll() {
      this.$store.dispatch(`eventManagement/${GET_GAllERY}`);
    },
    getImages() {
      this.$store.dispatch(`eventManagement/${GET_IMAGES}`);
    },
    getVideos() {
      this.$store.dispatch(`eventManagement/${GET_VIDEOS}`);
    },

  },
  watch: {
    selectedTab() {
      this.getData();
    }
  },
  computed: {
    ...mapState({
      gallery: state => state.eventManagement.gallery,
      loading: state => state.eventManagement.loading,
    })
  },
  async created() {
    const {data}=await getApi("categories/18")
    console.log(data)
    this.categories=data.categories;
    this.getAll();
  }

}
</script>

